import { HttpStatusCode, isAxiosError } from 'axios';

import { getDate } from '../timeService';
import {
  clinicianBridgeParamsStorageKey,
  mobileLoginCookieKey,
  SSO_REQUIRED_ERROR_MESSAGE,
} from './consts';
import type { IClinicianBridgeParams, IStoredClinicianBridgeParams } from './types';

export const isMobileAppContext = () =>
  Boolean(localStorage[mobileLoginCookieKey]) ||
  Boolean(localStorage.getItem(clinicianBridgeParamsStorageKey));

export const isSsoRequiredError = (error: unknown) =>
  isAxiosError<{ message?: string }>(error) &&
  error.response?.status === HttpStatusCode.Unauthorized &&
  error.response.data?.message === SSO_REQUIRED_ERROR_MESSAGE;

export const storeClinicianBridgeParams = (bridgeParams: IClinicianBridgeParams) => {
  const storedBridgeParams: IStoredClinicianBridgeParams = {
    ...bridgeParams,
    issuedAt: getDate().valueOf(),
  };
  localStorage.setItem(clinicianBridgeParamsStorageKey, JSON.stringify(storedBridgeParams));
};
